import { AREA, DataSecurityLevel, ERROR_CATEGORY, ERROR_COUNT, ERROR_DETAILS, ERROR_TYPE, EVENT_CATEGORY, EVENT_NAME, PAGE_APP_NAME, PAGE_NAME, PAGE_TYPE, SUB_AREA, } from '@office-start/telemetry-types';
import { convertRouteToPage, getFlattenedFieldName, getPageAppName, getPageType, } from '@office-start/telemetry-utility';
import { getCurrentRouteItem, isRouteInitialized, logEvent, } from '../TelemetryService';
/**
 * Logs error event with given properties.
 * All error events will be stored into a single Kusto table `Office.Taos.Hub.Error`. (with properties EventName and ErrorType)
 * and Office.Taos.Hub.Diagnostic (with properties EventName, ErrorType, Message and DebugInfo)
 * [NOTE] `Office.Taos.Hub.Diagnostic` will not be added for now until we have a plan to prevent privacy leak.
 *
 *  @param properties Properties pertaining to error event
 *                    - eventName: KnownErrorInstrumentationEvents;
 *                    - errorType?: ErrorType;
 *                    - message?: string;
 *                    - debugInfo?: string;
 *                    - errorCategory?: ErrorCategories;
 *                    - occurrenceCount?: number;
 *  @param securityThreshold DataSecurityLevel corresponds to Windows PlatformDataCollectionLevel which are ignored outside UWP.
 *
 * e.g.
 *     logError(
 *          {
 *              eventName: KnownErrorInstrumentationEvents.NotificationServiceError,
 *         }
 *      );
 */
// TODO: Need to modify and log debug events once we have plan
export function logError(properties, securityThreshold) {
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    logEvent("Error" /* EventCategory.Error */, generateErrorParams(properties), securityThreshold);
}
export function generateErrorParams(properties) {
    var _a, _b, _c, _d;
    var params = {};
    params[EVENT_CATEGORY] = "Error" /* EventCategory.Error */;
    params[EVENT_NAME] = properties.eventName;
    params[getFlattenedFieldName([ERROR_DETAILS, ERROR_TYPE])] =
        (_a = properties.errorType) !== null && _a !== void 0 ? _a : '';
    params[getFlattenedFieldName([ERROR_DETAILS, AREA])] =
        (_b = properties.area) !== null && _b !== void 0 ? _b : '';
    params[getFlattenedFieldName([ERROR_DETAILS, SUB_AREA])] =
        (_c = properties.subArea) !== null && _c !== void 0 ? _c : '';
    params[getFlattenedFieldName([ERROR_DETAILS, ERROR_CATEGORY])] =
        (_d = properties.errorCategory) !== null && _d !== void 0 ? _d : '';
    if (properties.occurrenceCount) {
        params[getFlattenedFieldName([ERROR_DETAILS, ERROR_COUNT])] =
            properties.occurrenceCount;
    }
    if (isRouteInitialized()) {
        var pageName = convertRouteToPage(getCurrentRouteItem());
        params[getFlattenedFieldName([ERROR_DETAILS, PAGE_NAME])] = pageName;
        params[getFlattenedFieldName([ERROR_DETAILS, PAGE_TYPE])] =
            getPageType(pageName);
        params[getFlattenedFieldName([ERROR_DETAILS, PAGE_APP_NAME])] =
            getPageAppName(pageName);
    }
    return params;
}
//# sourceMappingURL=logError.js.map